import { render, staticRenderFns } from "./AirQualityPanel.vue?vue&type=template&id=9bdc74f4"
import script from "./AirQualityPanel.vue?vue&type=script&lang=js"
export * from "./AirQualityPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports